// extracted by mini-css-extract-plugin
export var notificationHost = "_ma-0";